import { Controller } from "@hotwired/stimulus"
import {
  MONTHS_AHEAD, monthCells, monthTitle, pickDate, calendarHint, toISO, parseISO, monthOffset
} from "../modules/discount_schedule.mjs"

// Calendario de rango de "Del día": escribe start_date / end_date ISO en los hidden y dispara `input`;
// reglas en discount_schedule.mjs, tope desde Discount::ALL_DAY_MAX_DAYS.
// Doc: _docs/features/products/partner_product_form.md
export default class extends Controller {
  static targets = ["start", "end", "title", "grid", "prev", "next", "hint"]
  static values = {
    today: String,
    monthsAhead: { type: Number, default: MONTHS_AHEAD },
    maxDays: Number
  }

  connect() {
    this.today = this.todayValue || toISO(new Date())
    this.picking = false
    this.offset = monthOffset(this.today, this.startTarget.value, this.monthsAheadValue)
    this.render()
  }

  // discount-form lo llama al pasar a "Del día" sin fechas: hoy, un día
  setRange(start, end = start) {
    this.startTarget.value = start
    this.endTarget.value = end
    this.picking = false
    this.offset = monthOffset(this.today, start, this.monthsAheadValue)
    this.render()
    this.#notify()
  }

  prev() {
    if (this.offset === 0) return
    this.offset -= 1
    this.render()
  }

  next() {
    if (this.offset >= this.monthsAheadValue) return
    this.offset += 1
    this.render()
  }

  pick(event) {
    const next = pickDate(this.range, event.currentTarget.dataset.iso, this.maxDaysValue)
    this.startTarget.value = next.start
    this.endTarget.value = next.end
    this.picking = next.picking
    this.render()
    this.#notify()
  }

  get range() {
    return { start: this.startTarget.value, end: this.endTarget.value, picking: this.picking }
  }

  render() {
    const { year, month } = this.#viewMonth()
    this.titleTarget.textContent = monthTitle(year, month)
    this.prevTarget.disabled = this.offset === 0
    this.nextTarget.disabled = this.offset >= this.monthsAheadValue
    const cells = monthCells({ year, month, today: this.today, ...this.range, maxDays: this.maxDaysValue })
    this.gridTarget.replaceChildren(...cells.map(cell => this.#cell(cell)))
    const hint = calendarHint(this.range, this.maxDaysValue)
    this.hintTarget.textContent = hint.text
    this.hintTarget.classList.toggle("is-picking", hint.tone === "picking")
  }

  #cell(cell) {
    const wrapper = document.createElement("div")
    wrapper.className = `range-cal__cell range-cal__cell--${cell.band}`
    const button = document.createElement("button")
    button.type = "button"
    button.className = "range-cal__day"
    button.textContent = cell.day
    button.dataset.iso = cell.iso
    button.dataset.action = "range-calendar#pick"
    button.disabled = cell.disabled
    button.classList.toggle("is-out", !cell.inMonth)
    button.classList.toggle("is-selected", cell.isStart || cell.isEnd)
    button.classList.toggle("is-in-range", cell.inRange)
    button.classList.toggle("is-today", cell.isToday)
    button.setAttribute("aria-pressed", cell.isStart || cell.isEnd)
    button.setAttribute("aria-label", `${cell.day} de ${monthTitle(parseISO(cell.iso).getFullYear(), parseISO(cell.iso).getMonth()).toLowerCase()}`)
    wrapper.appendChild(button)
    return wrapper
  }

  #viewMonth() {
    const today = parseISO(this.today)
    const first = new Date(today.getFullYear(), today.getMonth() + this.offset, 1)
    return { year: first.getFullYear(), month: first.getMonth() }
  }

  #notify() {
    this.startTarget.dispatchEvent(new Event("input", { bubbles: true }))
  }
}
